// extracted by mini-css-extract-plugin
export default {"-large":"masking-panel-module__-large--KjsiP","dropdown":"masking-panel-module__dropdown--HeXos","dropdownList":"masking-panel-module__dropdownList--qqO4e"};